import { useState } from 'react'

export const useOriginalTopicSubTopic = (prevPath: string) => {
  const [topicSlug, setTopicSlug] = useState<string | null>(null)
  const [subTopicSlug, setSubTopicSlug] = useState<string | null>(null)
  const [companySlug, setCompanySlug] = useState<string | null>(null)

  if (!prevPath) {
    topicSlug && setTopicSlug(null)
    subTopicSlug && setSubTopicSlug(null)
    companySlug && setCompanySlug(null)
  } else {
    if (prevPath.startsWith('/topics/')) {
      const segments = prevPath.split('/')

      const newTopicSlug = segments[2] || null
      topicSlug !== newTopicSlug && setTopicSlug(newTopicSlug)

      const newSubTopicSlug = segments[3] && segments[3] !== '#' ? segments[3] : null
      subTopicSlug !== newSubTopicSlug && setSubTopicSlug(newSubTopicSlug)
    } else if (prevPath.startsWith('/companies/')) {
      const segments = prevPath.split('/')
      const newCompanySlug = segments[2] || null
      companySlug !== newCompanySlug && setCompanySlug(newCompanySlug)
    } else {
      topicSlug && setTopicSlug(null)
      subTopicSlug && setSubTopicSlug(null)
      companySlug && setCompanySlug(null)
    }
  }

  return {
    topicSlug,
    subTopicSlug,
    companySlug,
  }
}
